module.exports = __webpack_public_path__ + "static/media/5.2eb9202d.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_110/images/九宫格未选中态/5.png
// module id = 1066
// module chunks = 0